import Vue from 'vue'
import input_cash from './input-cash/input-cash.vue'
Vue.component('input-cash', input_cash);
import input_certificate_type from './input-certificate-type/input-certificate-type.vue'
Vue.component('input-certificate-type', input_certificate_type);
import input_contragent from './input-contragent/input-contragent.vue'
Vue.component('input-contragent', input_contragent);
import input_contragent_type from './input-contragent-type/input-contragent-type.vue'
Vue.component('input-contragent-type', input_contragent_type);
import input_course from './input-course/input-course.vue'
Vue.component('input-course', input_course);
import input_currency from './input-currency/input-currency.vue'
Vue.component('input-currency', input_currency);
import input_date from './input-date/input-date.vue'
Vue.component('input-date', input_date);
import input_dictionary from './input-dictionary/input-dictionary.vue'
Vue.component('input-dictionary', input_dictionary);
import input_invoice from './input-invoice/input-invoice.vue'
Vue.component('input-invoice', input_invoice);
import input_kind_of_pay from './input-kind-of-pay/input-kind-of-pay.vue'
Vue.component('input-kind-of-pay', input_kind_of_pay);
import input_owner_legal_entity from './input-owner-legal-entity/input-owner-legal-entity.vue'
Vue.component('input-owner-legal-entity', input_owner_legal_entity);
import input_payment_account from './input-payment-account/input-payment-account.vue'
Vue.component('input-payment-account', input_payment_account);
import input_payment_category from './input-payment-category/input-payment-category.vue'
Vue.component('input-payment-category', input_payment_category);
import input_payment_direction from './input-payment-direction/input-payment-direction.vue'
Vue.component('input-payment-direction', input_payment_direction);
import input_payment_operation from './input-payment-operation/input-payment-operation.vue'
Vue.component('input-payment-operation', input_payment_operation);
import input_payment_type from './input-payment-type/input-payment-type.vue'
Vue.component('input-payment-type', input_payment_type);
import input_price from './input-price/input-price.vue'
Vue.component('input-price', input_price);
import input_rate_article from './input-rate-article/input-rate-article.vue'
Vue.component('input-rate-article', input_rate_article);
import input_regular from './input-regular/input-regular.vue'
Vue.component('input-regular', input_regular);
import input_select_date from './input-select-date/input-select-date.vue'
Vue.component('input-select-date', input_select_date);
import input_text from './input-text/input-text.vue'
Vue.component('input-text', input_text);
import input_textarea from './input-textarea/input-textarea.vue'
Vue.component('input-textarea', input_textarea);
import input_select_tree from './input-select-tree/input-select-tree.vue'
Vue.component('input-select-tree', input_select_tree);
import './index.scss'
